import { connect, MapDispatchToProps } from 'react-redux';
import { Props } from './CommentButton';
import { focusCommentEditor } from '../../../DeviationPage/redux/actions';

type DispatchProps = Pick<Props, 'onFocusCommentEditor'>;
type OwnProps = Omit<Props, keyof DispatchProps>;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  onFocusCommentEditor: focusCommentEditor,
};

export default connect(undefined, mapDispatchToProps);
